import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { fetchActiveEvents } from '../services/rideService';

const BANNER_DISMISSED_KEY = 'collectedaf_events_banner_dismissed';

interface EventsBannerProps {
  onGoToEvents: () => void;
  onDismiss: () => void;
  isDismissed: boolean;
}

const EventsBanner: React.FC<EventsBannerProps> = ({ onGoToEvents, onDismiss, isDismissed }) => {
  const [eventTitle, setEventTitle] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActiveEvents()
      .then((events) => {
        const title = events.length > 0 ? events[0].title : null;
        setEventTitle(title);
      })
      .catch(() => setEventTitle(null))
      .finally(() => setLoading(false));
  }, []);

  if (isDismissed) return null;
  const displayText = eventTitle
    ? eventTitle.toLowerCase().startsWith('free rides to ')
      ? `${eventTitle}!`
      : `Free rides to ${eventTitle}!`
    : 'Free rides to events!';

  return (
    <div className="relative z-[60] w-full bg-BLACK/95 backdrop-blur-sm border-b border-ORANGE/40 shadow-lg">
      <div className="flex items-center justify-center gap-3 px-4 py-3 min-h-[48px] sm:min-h-[52px]">
        <button
          onClick={onGoToEvents}
          className="flex-1 flex items-center justify-center gap-2 text-WHITE hover:text-ORANGE transition-colors group max-w-3xl"
        >
          <span className="text-sm sm:text-base font-semibold tracking-wide group-hover:underline decoration-2 underline-offset-2">
            {displayText}
          </span>
          <span className="text-ORANGE text-xs sm:text-sm font-bold shrink-0">→ Get yours</span>
        </button>
        <button
          onClick={onDismiss}
          aria-label="Dismiss banner"
          className="p-2 -m-2 text-WHITE/70 hover:text-WHITE hover:bg-WHITE/10 rounded-full transition-colors shrink-0"
        >
          <FaTimes size={18} />
        </button>
      </div>
    </div>
  );
};

export default EventsBanner;
export { BANNER_DISMISSED_KEY };
